function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Shape",
  width: 24,
  height: 24,
  fill: "#7e27e4",
  opacity: 0
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148959",
  d: "M18.266,9.145A2.355,2.355,0,1,0,15.911,6.79,2.373,2.373,0,0,0,18.266,9.145ZM6.367,17.6H17.378a1.945,1.945,0,0,0,2.082-2.226v-5.5a2.774,2.774,0,0,1-1.277.218v5.147l-3.693-3.659L16.5,9.6a2.956,2.956,0,0,1-.853-.792l-3.072,3.031a1.124,1.124,0,0,1-.778.4,1.124,1.124,0,0,1-.778-.4L6.053,6.926a1.542,1.542,0,0,1,.321-.034h8.588a2.827,2.827,0,0,1,.2-1.283H6.2A1.942,1.942,0,0,0,4.121,7.834v7.543A2,2,0,0,0,6.367,17.6ZM5.4,7.93l3.714,3.652L5.4,15.255Zm6.4,5.53a2.068,2.068,0,0,0,1.481-.689l.375-.369,3.9,3.871a1.353,1.353,0,0,1-.348.041H6.374a1.749,1.749,0,0,1-.341-.034L9.944,12.4l.369.369A2.082,2.082,0,0,0,11.8,13.459Z",
  transform: "translate(-0.371 0.981)"
});

function SvgUnreadEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sun_Brightens",
    "data-name": "Sun / Brightens",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadEmail);
export default __webpack_public_path__ + "static/media/unread_email.b92071db.svg";
export { ForwardRef as ReactComponent };